import React, { FunctionComponent, ReactNode } from "react";
import { useIntl } from "react-intl";
import Button from "../../atoms/Button";
import Modal from "../Modal";
import "./style.scss";

interface Props {
  children: ReactNode;
  confirmLabel?: string;
  dismissLabel?: string;
  display: boolean;
  onClose?: () => void;
  onConfirm?: () => void;
  onDismiss: () => void;
  showCloseButton?: boolean;
  showDismissButton?: boolean;
  validationButtonType?: "error" | "primary" | "warning";
}

const ConfirmModal: FunctionComponent<Props> = ({
  children,
  confirmLabel,
  dismissLabel,
  display,
  onClose,
  onConfirm,
  onDismiss,
  showCloseButton = true,
  showDismissButton = true,
  validationButtonType = "primary",
}) => {
  const intl = useIntl();

  return (
    <Modal display={display} onDismiss={onClose || onDismiss} showCloseButton={showCloseButton}>
      <div className="ConfirmModal">
        <div className="ConfirmModal-content">{children}</div>

        <div className="ConfirmModal-footer">
          <Button type={validationButtonType} onClick={onConfirm || onDismiss}>
            {confirmLabel || intl.formatMessage({ id: "kustom_ConfirmModal_ok" })}
          </Button>

          {showDismissButton ? (
            <Button type="neutral-inverted" onClick={onDismiss}>
              {dismissLabel || intl.formatMessage({ id: "kustom_ConfirmModal_cancel" })}
            </Button>
          ) : null}
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmModal;
